module.exports = __webpack_public_path__ + "img/ma.43807c8d.svg";